import Vue from 'vue'

function tradeRevertBlockedReason (trade) {
  const reason = (trade && trade.revert_blocked_reason) || 'This trade was already reverted.'
  if (reason.includes('This trade was already reverted.')) {
    return 'This trade was already reverted.'
  }
  return reason
}

// initial state
const state = {
  all: null,
  lastReverted: null
}

// getters
const getters = {
  Tradelogs: state => state.all,
  lastTradeRevert: state => state.lastReverted

}

// actions
const actions = {
  getTradelog ({ commit }, trades) {
    commit('setTradelog', trades)
  },
  setTradelog ({ commit }, trades) {
    commit('setTradelog', trades)
  },
  tradeReverted ({ commit, rootState }, trade) {
    const payload = trade && trade.data ? trade.data : trade
    const activeUser = rootState.userData && rootState.userData.userData ? rootState.userData.userData : null
    const activeUserId = activeUser && payload && activeUser.server === payload.server ? activeUser.id : null
    commit('markTradeReverted', payload)
    commit('applyTradeRevertUserData', payload)
    commit('applyTradeRevertInventory', {
      trade: payload,
      activeUserId: activeUserId
    })
  }
}

// mutations
const mutations = {
  setTradelog (state, products) {
    state.all = products
  },
  markTradeReverted (state, trade) {
    if (!trade) {
      return
    }

    const reason = tradeRevertBlockedReason(trade)
    const update = Object.assign({}, trade, {
      revert_blocked_reason: reason,
      time: Date.now()
    })

    if (state.all && state.all.data && state.all.data.server === trade.server && Array.isArray(state.all.data.data)) {
      const row = state.all.data.data.find(item => item.id === trade.trade_id)
      if (row) {
        Vue.set(row, 'can_revert', false)
        Vue.set(row, 'revert_blocked_reason', reason)
      }
    }

    Vue.set(state, 'lastReverted', update)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
